export default __webpack_public_path__ + "static/media/Spiral-big.77c3e5bd.png";